export const CANONICAL_DOMAIN = "https://midefinca.es";

export const business = {
  brand: "MideFinca",
  legalName: "Joana Rodríguez González",
  nif: "54064778N",
  legalAddress: "Calle Santiago Cuadrado 15, Pl. 0, Pta. Izq., 38006 Santa Cruz de Tenerife",
  professionalName: null, // La titular prefiere perfil impersonal: sin nombre público
  qualification: "Arquitecto",
  collegiate: "Colegio Oficial de Arquitectos de Tenerife, La Gomera y El Hierro",
  email: "info@midefinca.es",
  phoneDisplay: "656 96 36 72",
  phoneHref: "tel:+34656963672",
  whatsappUrl:
    "https://wa.me/34656963672?text=" +
    encodeURIComponent(
      "Hola, contacto desde MideFinca. Quería consultar un caso relacionado con una finca/inmueble."
    ),
  serviceArea: "Canarias",
  address: null, // No publicar dirección hasta facilitar ubicación pública real
  openingHours: null, // [PENDIENTE: horario para Google Business Profile]
  socialProfiles: [], // [PENDIENTE: perfiles sociales]
};

export const nav = [
  { label: "Inicio", href: "/" },
  { label: "Servicios", href: "/servicios/" },
  { label: "Problemas", href: "/problemas/" },
  { label: "Guías", href: "/guias/" },
  { label: "Profesionales", href: "/profesionales/" },
  { label: "Sobre MideFinca", href: "/sobre-midefinca/" },
  { label: "Contacto", href: "/contacto/" },
];

export const municipalitiesByIsland = [
  {
    island: "Tenerife",
    towns: ["Adeje", "Arafo", "Arico", "Arona", "Buenavista del Norte", "Candelaria", "El Rosario", "El Sauzal", "El Tanque", "Fasnia", "Garachico", "Granadilla de Abona", "Guía de Isora", "Güímar", "Icod de los Vinos", "La Guancha", "La Matanza de Acentejo", "La Orotava", "La Victoria de Acentejo", "Los Realejos", "Los Silos", "Puerto de la Cruz", "San Cristóbal de La Laguna", "San Juan de la Rambla", "San Miguel de Abona", "Santa Cruz de Tenerife", "Santa Úrsula", "Santiago del Teide", "Tacoronte", "Tegueste", "Vilaflor de Chasna"],
  },
  {
    island: "Gran Canaria",
    towns: ["Agaete", "Agüimes", "Artenara", "Arucas", "Firgas", "Gáldar", "Ingenio", "La Aldea de San Nicolás", "Las Palmas de Gran Canaria", "Mogán", "Moya", "San Bartolomé de Tirajana", "Santa Brígida", "Santa Lucía de Tirajana", "Santa María de Guía", "Tejeda", "Telde", "Teror", "Valleseco", "Valsequillo de Gran Canaria", "Vega de San Mateo"],
  },
  {
    island: "Fuerteventura",
    towns: ["Antigua", "Betancuria", "La Oliva", "Pájara", "Puerto del Rosario", "Tuineje"],
  },
  {
    island: "Lanzarote",
    towns: ["Arrecife", "Haría", "San Bartolomé", "Teguise", "Tías", "Tinajo", "Yaiza"],
  },
  {
    island: "La Palma",
    towns: ["Barlovento", "Breña Alta", "Breña Baja", "El Paso", "Fuencaliente", "Garafía", "Los Llanos de Aridane", "Puntagorda", "Puntallana", "San Andrés y Sauces", "Santa Cruz de la Palma", "Tazacorte", "Tijarafe", "Villa de Mazo"],
  },
  {
    island: "La Gomera",
    towns: ["Agulo", "Alajeró", "Hermigua", "San Sebastián de La Gomera", "Valle Gran Rey", "Vallehermoso"],
  },
  {
    island: "El Hierro",
    towns: ["El Pinar", "La Frontera", "Valverde"],
  },
];

export const needOptions = [
  "Medir una finca o terreno",
  "Levantamiento topográfico",
  "Georreferenciación de finca",
  "Archivo GML para Catastro / Registro",
  "Comprobar o marcar linderos",
  "Corregir datos de Catastro",
  "Segregar una finca en dos o más parcelas",
  "Agrupar varias fincas en una sola",
  "Comprobar una finca antes de comprar",
  "Declarar una obra nueva",
  "Declarar una ampliación",
  "Certificado de antigüedad",
  "Certificado de habitabilidad",
  "Primera ocupación de edificación fuera de ordenación",
  "Informe de uso consolidado",
  "Cédula urbanística",
  "Alineaciones y rasantes",
  "Comunicación previa de obra",
  "Licencia de obra mayor",
  "División horizontal de un edificio",
  "Cambio de uso de local a vivienda",
  "No lo tengo claro: quiero contar mi caso",
];

export const homeFaqs = [
  {
    q: "¿Trabajáis en todas las islas?",
    a: "Sí. Realizamos mediciones y levantamientos en las siete islas, tanto en fincas rústicas como urbanas. Cuéntanos dónde está la finca y te confirmamos disponibilidad y presupuesto.",
  },
  {
    q: "¿Cuánto cuesta medir una finca?",
    a: "Depende de la superficie, la orografía, el acceso y la documentación disponible. Cada encargo se valora de forma individual: cuéntanos tu caso y te preparamos un presupuesto previo, cerrado y sin compromiso.",
  },
  {
    q: "¿Vuestro trabajo sirve para Catastro o para el Registro?",
    a: "Nuestra documentación técnica (planos, mediciones, archivos GML, certificados) es la base que suelen requerir estos trámites. La aceptación final corresponde siempre a Catastro, al notario o al registrador, y puede depender del caso concreto.",
  },
  {
    q: "No sé qué servicio necesito. ¿Qué hago?",
    a: "Es lo más habitual. Cuéntanos tu problema con tus palabras (por ejemplo, «Catastro tiene menos metros» o «no sé dónde acaba mi terreno») y te indicamos qué trabajo técnico necesitas, si lo necesitas.",
  },
  {
    q: "¿Necesito tener la escritura o la referencia catastral?",
    a: "No es imprescindible para una primera consulta, pero agiliza mucho la valoración. La referencia catastral nos permite revisar la cartografía y los datos registrales antes de la visita.",
  },
  {
    q: "¿Hacéis trámites notariales o registrales?",
    a: "No. Somos un servicio técnico: medimos, documentamos y elaboramos la parte técnica. Las actuaciones notariales, registrales o administrativas corresponden a notarios, registradores y administraciones, con los que colaboramos cuando el expediente lo requiere.",
  },
];
